import "./infodisplay.css";
export function InfoDisplay() {
  return <p>What would you like to know?</p>;
}
